export default "__VITE_ASSET__Csuz_YIW__"